<template>
    <div class="UpLoadingVideo" style="background-color: #ffffff">
        <div class="VideoHeader" v-if="start">
            <div class="VideoTit">
                请牢记以下文字，点击"开始录像"按钮后，正视摄像头，大声背诵以下内容：
            </div>
            <div class="VideoCon">
                "我是({{ info.name }}),今天是{{ Time }},({{
                    info.phone
                }})'是我办理的手机号码,本人承诺依法合规使用,知晓电话卡涉诈的法律风险。"
            </div>
        </div>
        <input
            ref="inputVideo"
            type="file"
            name="video"
            id="video-input"
            accept="video/*"
            capture="camcorder"
            enctype="multipart/form-data"
            @change="videoChange"
        />

        <!-- <--video用于播放拍摄后的内容-->
        <video
            v-if="finish"
            id="video"
            width="100%"
            height="800"
            controls
            autoplay
        ></video>

        <div class="Start">
            <van-button class="StartButton" v-if="start" @click="onVideo"
                >开始录像</van-button
            >
        </div>

        <div class="finish" v-if="finish">
            <van-button class="FinishButton" @click="anew">重新录制</van-button>
            <van-button class="FinishButton" @click="Uploading(fileUrl)"
                >录制成功，提交上传审核！！！</van-button
            >
        </div>
    </div>
</template>
  <script>
import API from "../../../common/api/api"
import Lanmao from "../../../components/lanmao/index"
import axios from "axios"
export default {
    name: "skippingRopeIndex",
    data() {
        return {
            start: true, //按钮显示隐藏
            finish: false, //完成
            Time: "", //获取的当前时间
            fileUrl: "", //视频地址
            info: "", //基本信息
        }
    },

    created() {
        this.Times()
        this.Ltokens()
    },
    methods: {
        // 获取当前时间
        Times() {
            var date = new Date()
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()
            this.Time = year + "年" + month + "月" + day + "日"
        },

        // 二维码进入调取获取Ltoken接口
        Ltokens() {
            let LtokenData = JSON.parse(localStorage.getItem("LtokenData"))
            API.getJson("GETVIDEOTOKEN", {
                Ltoken: LtokenData,
            }).then(res => {
                this.info = res
            })
        },

        //点击button实现调起录制摄像头
        onVideo() {
            const that = this
            that.$refs.inputVideo.click()
            this.start = false
            this.finish = true
        },

        //视频录制结束后将视频路径赋值给video标签进行播放
        videoChange() {
            let file = document.getElementById("video-input").files[0]
            let url = URL.createObjectURL(file) //将视频转换为blob类型
            this.fileUrl = file
            document.getElementById("video").src = url //视频播放
        },

        // 上传视频
        Uploading(ssss) {
            // let token = localStorage.getItem("token")
            const file = ssss
            console.log("视频", file)
            const formdata = new FormData()
            formdata.append("video", file)
            formdata.append("token", this.info.token)
            formdata.append("name", this.info.RegistNumber)
            Lanmao.loading.show("加载中...")

            // console.log("888888888888", formdata.getAll("video"))
            // console.log("999999999999", formdata.get("video"))
            

            axios({
                method: "POST",
                url: "http://wechat.bw30hl.com/api/wechat/realNameFile",//生产
                // url: "http://172.16.30.14:18080/api/wechat/realNameFile", //本地
                header: {
                    "Content-Type": "multipart/form-data",
                },
                formData: {
                    user: "test",
                },
                data: formdata,
            }) //请求头要为表单
                .then(res => {
                    console.log("res",res);
                    Lanmao.loading.hide()
                    if (res.status == 200) {
                        Lanmao.alert({
                            title: "提示",
                            message: "实名认证开机受理成功",
                            confirm: () => {
                                this.$router.push("/realName")
                                localStorage.removeItem("LtokenData")
                            },
                        })
                    }
                })
                .catch(function (error) {
                    Lanmao.loading.hide()
                    Lanmao.alert({
                        title: "提示",
                        message: "视频上传失败，请稍后重试",
                        confirm: () => {
                            localStorage.removeItem("LtokenData")
                            // this.$router.push("/realName")
                            // window.location.href =
                            //     "http://localhost:8080/realName" //本地测试
                            window.location.href = 'http://wechat.bw30hl.com/realName'; //线上
                        },
                    })
                })

            // try{
            //     console.log("抛异常测试",aaa)
            // }
            // catch(err){
            //     console.log("抛异常成功")
            // }
        },

        // 重新录制视频
        anew() {
            document.getElementById("video").src = ""
            this.start = true
            this.finish = false
        },
    },
}
</script>
  <style lang="scss" scoped>
.UpLoadingVideo {
    width: 100%;
    .VideoHeader {
        width: 100%;

        .VideoTit {
            text-align: center;
            padding: px2rem(30) px2rem(20);
        }
        .VideoCon {
            text-align: center;
            padding: px2rem(20) px2rem(40);
            font-size: px2rem(36);
            line-height: px2rem(44);
            color: #509bf5;
        }
    }

    .Start {
        width: 100%;
        height: px2rem(80);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: px2rem(220);

        .StartButton {
            width: 80%;
            height: 100%;
            background-color: #509bf5;
            font-size: px2rem(28);
            border-radius: px2rem(18);
            font-weight: bold;
            color: #ffffff;
        }
    }

    .finish {
        width: 100%;
        height: px2rem(220);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;

        .FinishButton {
            width: 80%;
            height: 36%;
            background-color: #509bf5;
            font-size: px2rem(28);
            border-radius: px2rem(18);
            font-weight: bold;
            color: #ffffff;
        }
    }

    #video-input {
        display: none;
        /*-webkit-filter:grayscale(100%)*/
    }

    #video {
        margin-top: px2rem(60);
    }
}
</style>